export default "__VITE_ASSET__D$UiS8Mk__"